/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Policy_CancelInputs */

const en_price_page_policy_cancel = /** @type {(inputs: Price_Page_Policy_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel visit`)
};

const pl_price_page_policy_cancel = /** @type {(inputs: Price_Page_Policy_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odwołaj wizytę`)
};

/**
* | output |
* | --- |
* | "Cancel visit" |
*
* @param {Price_Page_Policy_CancelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_policy_cancel = /** @type {((inputs?: Price_Page_Policy_CancelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Policy_CancelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_policy_cancel(inputs)
	return en_price_page_policy_cancel(inputs)
});